<template>
  <div class="nav-menu">
    <!-- pc端 -->
    <el-row class="pc">
      <!-- 左边logo -->
      <el-col :span="4">
        <div class="grid-content">
          <a href="/" target="_blank">
            <img src="../../assets/images/ora_logo.png" alt="" />
          </a>
        </div>
      </el-col>
      <!-- 导航页面切换 -->
      <el-col :span="13">
        <div class="grid-content textcs">
          <el-menu
            :default-active="$route.path"
            mode="horizontal"
            @select="menuClick"
          >
            <el-menu-item index="/home">{{ $t("myhome") }}</el-menu-item>
            <el-menu-item index="/brand">{{ $t("brand") }}</el-menu-item>
            <el-menu-item index="/InfoCollection">{{ $t("InfoCollection") }}</el-menu-item>
            <!-- <el-menu-item index="/contractUs">{{ $t("contact") }}</el-menu-item> -->
          </el-menu>
        </div>
      </el-col>
      <!-- 右边 pc端 语言切换 -->

      <!-- <el-col :lg="7" :md="24" :sm="24" :xs="0"> -->
      <div class="navmenu">
        <el-menu
          :default-active="$route.path"
          mode="horizontal"
          class="el-menu-demo"
          @select="handleSelect"
          active-text-color="#000000"
        >
          <el-col :lg="2" :md="2" :xs="0" :sm="3" style="outline: none">
            <el-submenu index="">
              <template slot="title">
                <div v-if="lang === 'en'">
                  <span slot="title">
                    <template>
                      <img
                        class="langlogo"
                        src="@/assets/images/group.png"
                        alt=""
                      />
                      <div class="endeword">
                        {{ $t("en") }}
                      </div>
                    </template>
                  </span>
                </div>
                <div v-else>
                  <span slot="title">
                    <template>
                      <img
                        class="langlogo"
                        src="@/assets/images/group.png"
                        alt=""
                      />
                      <div class="endeword">
                        {{ $t("de") }}
                      </div>
                    </template>
                  </span>
                </div>
              </template>
              <el-row>
                <div v-if="lang === 'en'">
                  <el-col class="check"><i class="el-icon-check"></i></el-col>
                  <el-menu-item
                    class="language"
                    index=""
                    @click="changeLang('en')"
                    >{{ $t("english") }}</el-menu-item
                  >
                  <el-col class="check"></el-col>
                  <el-menu-item
                    class="language"
                    index=""
                    @click="changeLang('de')"
                    >{{ $t("deutsch") }}</el-menu-item
                  >
                </div>
                <div v-else>
                  <el-col class="check"></el-col>
                  <el-menu-item
                    class="language"
                    index=""
                    @click="changeLang('en')"
                    >{{ $t("english") }}</el-menu-item
                  >
                  <el-col class="check"><i class="el-icon-check"></i> </el-col>
                  <el-menu-item
                    class="language"
                    index=""
                    @click="changeLang('de')"
                    >{{ $t("deutsch") }}</el-menu-item
                  >
                </div>
              </el-row>
            </el-submenu>
          </el-col>
        </el-menu>
      </div>
      <!-- </el-col> -->
    </el-row>
    <!-- 移动端 -->
    <el-row class="mobile">
      <el-col :span="24">
        <div class="grid-content">
          <a href="/" target="_blank">
            <img src="../../assets/images/ora_logo.png" />
          </a>
          <img
            src="../../assets/images/Group 11821.png"
            @click="showdiv()"
            id="btnshow"
          />
        </div>
      </el-col>
    </el-row>
    <div class="mobilediolog">
      <HomeMenu></HomeMenu>
    </div>
  </div>
</template>
<script>
import HomeMenu from "../menu/homeMenu.vue";
import i18n from "../../i18n";

export default {
  name: "nav-menu",
  data() {
    return {
      activeIndex: "1",
      lang: "",
      pageroute: "",
    };
  },
  created() {
    this.lang = localStorage.getItem("locale") || "en";
    this.pageroute = this.$route;
    console.log(this.pageroute.name);
    console.log(this.lang);
  },
  components: {
    HomeMenu,
  },

  methods: {
    changeLang(lang) {
      i18n.locale = lang;
      localStorage.setItem("locale", lang);
      this.lang = lang;
    },
    handleChange(value) {
      console.log(value);
    },
    handleSelect() {},

    showdiv: function () {
      document.getElementById("bg").style.display = "block";
      document.getElementById("show").style.display = "block";
    },
    hidediv: function () {
      document.getElementById("bg").style.display = "none";
      document.getElementById("show").style.display = "none";
    },
    menuClick(index) {
      window.open('#' + index, '_blank')
    }
  },
};
</script>
<style>
@media screen and (min-width: 768px) {
  .mobile {
    display: none;
  }

  .nav-menu {
    /* margin: 66px 0; */
    margin: 35px 0 60px 0;
  }

  .grid-content {
    height: 80px;
  }
  .grid-content img {
    width: 39px;
  }

  .textcs {
    margin-left: -30px;
  }

  .el-menu.el-menu--horizontal {
    border-bottom: none;
  }

  .el-menu-demo {
    padding-top: 10px;
  }

  /* 下划线颜色 */
  .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: 2px solid #303133;
    font-family: "NexaBold";
  }

  .el-menu--horizontal > .el-menu-item {
    float: left;
    height: 50px;
    font-size: 20px;
    line-height: 60px;
    border-bottom: 2px solid transparent;
    color: #303133;
    padding: 0;
    margin: 0 20px;
  }

  .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
  .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
    outline: 0;
    color: #303133;
    font-weight: bold;
  }

  .navlogo {
    margin-top: 20px;
  }

  .langlogo {
    /* width: 60px;
      height: 60px; */
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: -25px;
    margin-top: 15px;
    height: 17px;
  }
  .check {
    width: 30px;
    height: 20px;
    margin-left: 15px;
    margin-top: 8px;
  }
  .language {
    margin-left: 50px;
    font-family: "NexaLight";
  }
  .endeword {
    color: black !important;
    width: 30px;
    height: 30px;
    margin-top: -35px;
    margin-left: -5px;
  }
  .border_dark {
    align-items: center;
    justify-content: center;
    display: flex;
    /* border: 1px solid black; */
    height: 30px;
    margin-top: 10px;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
    border-bottom-right-radius: 20px;
    border-bottom-left-radius: 20px;
  }

  .border_light {
    align-items: center;
    justify-content: center;
    display: flex;
    border: 1px solid rgb(7, 0, 0);
    height: 30px;
    margin-top: 10px;
    border-top-right-radius: 20px;
    border-top-left-radius: 20px;
    border-bottom-right-radius: 20px;
    border-bottom-left-radius: 20px;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
  }

  .el-submenu__title {
    font-size: 14px;
    color: #303133;
    padding: 3px 64px;
    cursor: pointer;
    transition: border-color 0.3s, background-color 0.3s, color 0.3s;
    box-sizing: border-box;
    margin-left: -28px;
    margin-top: -8px;
    background-color: transparent !important;
  }

  .el-submenu {
    list-style: none;
    margin: 0;
    padding-left: 0;
    border: 1px solid #333;
    width: 89px;
    border-radius: 29px;
    height: 39px;
  }
}

.navmenu {
  display: flex;
  justify-content: center;
}
.el-menu.el-menu--horizontal {
  border: none;
}

/* .el-menu--horizontal > .el-menu-item {
  border-bottom: none !important;
} */

.el-submenu__title:focus,
.el-submenu__title:hover {
  background: none !important;
}
::v-deep .el-submenu__title:hover {
  background: none !important;
}

@media (max-width: 767px) {
  /* .mobilediolog {
    width: 100%;
    height: 100%;
    position: fixed;
    background-color: white;
  } */
  .pc {
    display: none;
  }

  .grid-content {
    display: flex;
    justify-content: space-between;
    margin: 4%;
  }

  .grid-content img {
    height: 40px;
  }
  .soya-grid {
    display: flex;
    justify-content: flex-end;
    margin: 4%;
  }
}
</style>